<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay" md="12">
    <v-card class="pa-4 mb-6">
      <v-btn block elevation="4" @click="retrieveNewcomers">Reload</v-btn>
    </v-card>
    <v-card>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-card class="mb-4" variant="tonal" v-for="nc in newcomers" :key="nc['id']">
              <v-container>
                <v-row class="text-center">
                  <v-col cols="auto">
                    <v-card-text>
                      <b>id:</b><br/>{{ nc['id'] }}
                    </v-card-text>
                  </v-col>
                  <v-col>
                    <v-card-text>
                      <b>name:</b><br/>{{ nc['name'] }}
                    </v-card-text>
                  </v-col>
                  <v-col>
                    <v-card-text>
                      <b>time: </b><br/>{{ nc['time'] }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="auto">
                    <v-card-text>
                      <b>teamviewer id:</b><br/>{{ nc['teamviewerid'] }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="auto">
                    <v-card-text>
                      <b>anydesk id:</b><br/>{{ nc['anydeskid'] }}
                    </v-card-text>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center justify-center">
                    <v-btn
                      prepend-icon="mdi-console-line"
                      rounded="xl"
                      size="large"
                      color="black"
                      @click="routeToBonk(nc['name'])"
                    >BONK
                    </v-btn>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center justify-center">
                    <v-btn
                      density="compact"
                      icon="mdi-delete-forever"
                      size="x-large"
                      color="red"
                      @click="deleteNewcomer(nc['id'])"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </PanelPage>
</template>

<script setup>
import { onMounted, ref } from "vue";
import axios from 'axios';
import { objComparatorNumber } from "../utils.js";
import PanelPage from "../components/PanelPage.vue";
import { endpoint } from "../remote/utils.js";
import { routeToBonk } from "../remote/bonk.js";

// State
const useAlerts = ref(null);
const newcomers = ref([]);
const loadingOverlay = ref(false);

async function fetchNewcomers() {
  try {
    const res = await axios.get(endpoint("get_newcomers/"), {
      withCredentials: true
    });
    return res.data.sort((a, b) => -objComparatorNumber(a, b, 'id'));
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load MoneyDests', e.toString());
  }
}

async function deleteNewcomer(nc_id) {
  const payload = {
    id: nc_id
  };
  loadingOverlay.value = true;
  // Delete Newcomer via POST
  await axios.post(endpoint("cancelnewcomer/"), payload, {
    withCredentials: true
  }).then(response => {
    if (response.status !== 200) {
      useAlerts.value.warningAlert(`Anomalous return code!`, `${response.status} ${response.data}`);
    }
  }).catch(error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      useAlerts.value.errorAlert(`Error ${error.response.status}`, `${JSON.stringify(error.response.data)}`);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      useAlerts.value.errorAlert(`No response received!`, `${JSON.stringify(error.request)}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      useAlerts.value.errorAlert(`Unexpected Error!`, `${JSON.stringify(error.message)}`);
    }
  }).finally(async () => {
    newcomers.value = await fetchNewcomers();
    loadingOverlay.value = false;
  });
}

async function retrieveNewcomers() {
  loadingOverlay.value = true;
  try {
    newcomers.value = await fetchNewcomers();
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load Newcomers', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
}

onMounted(retrieveNewcomers);

</script>

<style scoped>

</style>
